import React, { Component, Fragment } from 'react'
import { Checkbox, Col, DatePicker, Form, Row } from 'antd'
import Clients from '../../../../../api/Sales/Clients'
import style from './style.css'
import CurrencySelect from '../../../../../elements/Select/Currency'
import { compose } from 'recompose'
import { get, isEmpty, set } from 'lodash'
import withSort from '../../../../../elements/HOC/withSort'
import withSubDropdown from '../../../../../elements/HOC/withSubDropdown'
import withSpinning from '../../../../../elements/HOC/withSpinning'
import CustomSelect from '../../../../../elements/Select/CustomSelect'
import withSelectFetch from '../../../../../elements/Select/withSelectFetch'
import withUrlFetch from '../../../../../elements/Select/withUrlFetch'
import { dateVal } from '../../../../../modules/Utils'
import InfoTooltip from '../../../../../elements/InfoTooltip'
import RecurringFrequency from '../../../../../elements/Select/Lines/RecurringFrequency'
import RecurringDay from '../../../../../elements/Select/Lines/RecurringDay'

const FormItem = Form.Item
const { RangePicker } = DatePicker

const BillingType = compose(
  withSelectFetch({ dropdown: 'client', name: 'billing' }),
  withSpinning,
  withSubDropdown({ name: 'type' }),
  withSort
)(CustomSelect)
const BillingIssuance = compose(
  withSelectFetch({ dropdown: 'client', name: 'billing' }),
  withSpinning,
  withSubDropdown({ name: 'issuance' }),
  withSort
)(CustomSelect)
const BillingCycle = compose(
  withSelectFetch({ dropdown: 'client', name: 'billing' }),
  withSpinning,
  withSubDropdown({ name: 'cycle' }),
  withSort
)(CustomSelect)

const PaymentTerms = compose(
  withSelectFetch({ dropdown: 'client', name: 'terms' }),
  withSpinning,
  withSubDropdown({ name: 'payment' }),
  withSort
)(CustomSelect)

class Payment extends Component {
  constructor(props) {
    super(props)
    this.api = new Clients()
    this.key = props.client._key
    const company = get(props.contract, 'company._id')
    const url = `corporates/banks/?status=Active` + (isEmpty(company) ? '' : `&owner=${company}`)
    this.BankSelectCmp = compose(
      withUrlFetch({
        name: 'banks',
        url: url,
        cache: true,
        forceFetch: true,
      }),
      withSpinning,
      withSort
    )(CustomSelect)
  }

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }
    const { getFieldDecorator } = this.props.form
    let contract = { ...this.props.contract }
    const { BankSelectCmp } = this
    return (
      <Form layout="horizontal">
        <Row>
          <h3 className={style.formSubtitle}>BILLING</h3>
          <Col span={12}>
            <FormItem label="Billing Type" {...formItemLayout}>
              {getFieldDecorator('billing.type', {
                initialValue: get(contract, 'billing.type'),
                rules: [
                  {
                    required: true,
                    message: "Billing Type can't be empty ",
                  },
                ],
              })(<BillingType placeholder="Billing Type" />)}
            </FormItem>
          </Col>
          {this.props.form.getFieldValue('billing.type') === 'auto' && (
            <Fragment>
              <Col span={12}>
                <Form.Item
                  {...formItemLayout}
                  label={<InfoTooltip value={'Billing Start'} title={'Date of first Invoice'} />}>
                  {getFieldDecorator('billing.period.start', {
                    initialValue: dateVal(contract, 'billing.period.start'),
                    rules: [
                      {
                        required: true,
                        message: "Billing Start Can't be empty!",
                      },
                    ],
                  })(<DatePicker style={{ width: '100%' }} />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <FormItem label="Billing Issuance" {...formItemLayout}>
                  {getFieldDecorator('billing.issuance', {
                    initialValue: get(contract, 'billing.issuance'),
                    rules: [
                      {
                        required: true,
                        message: "Billing Issuance can't be empty ",
                      },
                    ],
                  })(<BillingIssuance placeholder="Billing Issuance" />)}
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem label="Billing Cycle" {...formItemLayout}>
                  {getFieldDecorator('billing.cycle', {
                    initialValue: get(contract, 'billing.cycle'),
                    rules: [
                      {
                        required: true,
                        message: "Billing Cycle can't be empty ",
                      },
                    ],
                  })(<BillingCycle placeholder="Billing Cycle" />)}
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem label="Billing Frequency" {...formItemLayout}>
                  {getFieldDecorator('billing.period.frequency', {
                    initialValue: get(contract, 'billing.period.frequency'),
                    rules: [
                      {
                        required: true,
                        message: "Billing Frequency can't be empty ",
                      },
                    ],
                  })(<RecurringFrequency placeholder="Billing Frequency" />)}
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem label="Period End Day" {...formItemLayout}>
                  {getFieldDecorator('billing.period.day', {
                    initialValue: get(contract, 'billing.period.day'),
                    rules: [
                      {
                        required: true,
                        message: "Period End Day can't be empty ",
                      },
                    ],
                  })(<RecurringDay placeholder="Period End Day" />)}
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem label="Allow Manual Billing" {...formItemLayout}>
                  {getFieldDecorator('billing.manual', {
                    initialValue: get(contract, 'billing.manual'),
                    valuePropName: 'checked',
                  })(<Checkbox />)}
                </FormItem>
              </Col>
            </Fragment>
          )}
          <Col span={12} />
        </Row>
        <h3 className={style.formSubtitle}>PAYMENT TERMS</h3>
        <Row>
          <Col span={12}>
            <FormItem label="Payment Terms" {...formItemLayout}>
              {getFieldDecorator('pay.terms', {
                initialValue: get(contract, 'pay.terms'),
                rules: [
                  {
                    required: true,
                    message: "Payment Terms can't be empty ",
                  },
                ],
              })(<PaymentTerms placeholder="Payment Terms" />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Pay Currency" {...formItemLayout}>
              {getFieldDecorator('pay.currency', {
                initialValue: get(contract, 'pay.currency'),
                rules: [
                  {
                    required: true,
                    message: "Pay Currency can't be empty ",
                  },
                ],
              })(<CurrencySelect />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Bank Account" {...formItemLayout}>
              {getFieldDecorator('bank._id', {
                initialValue: get(contract, 'bank._id'),
                rules: [
                  {
                    required: true,
                    message: "Bank can't be empty ",
                  },
                ],
              })(<BankSelectCmp keyAtr={'_id'} valueAtr={'title'} placeholder={'Bank Account'} />)}
            </FormItem>
          </Col>
        </Row>
      </Form>
    )
  }
}

export default Form.create()(Payment)
